import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import update from "@beeldit/core/services/update";
import { DetailsActionContext } from "./DetailsActionContext";

function useUpdate() {
  const { element, setBackendFormErrors } = useContext(DetailsActionContext);
  const errorHandler = useErrorHandler();

  return (onSuccess: any) => {
    update("headers", element.id, element)
      .then((response: any) => {
        onSuccess(response.data);
      })
      .catch((error: any) => {
        errorHandler(error, setBackendFormErrors);
      });
  };
}

export default useUpdate;
